import { useEffect, useState } from 'react';
import LeftSidePopupLayout from './modal-layout';
import XCloseIcon from '../icons/x-close';
import Style from './style.module.css'
import { useApiCall } from '../custom-hooks/api-call';
import { useFormik } from 'formik';
import * as yup from "yup";
import { File, UploadCloud } from 'lucide-react';
import InnerLoader from '../ui/loader/inner-loader';
import { Link } from 'react-router';

const ContractModal = ({ onSubmit = () => { }, onClose = () => { }, onError = () => { }, contractData, vendorId, type }) => {
  const apiCall = useApiCall();
  const [contractError , setContractError] = useState(false);

  useEffect(() => {
    console.log("contractData", contractData);
    if (contractData?.id) {
      formik.setFieldValue("contract_issue_date", contractData?.start_date || "")
      formik.setFieldValue("contract_expiry_date", contractData?.expiry_date || "")
      formik.setFieldValue("contract", contractData?.contract_url || "")
      formik.setFieldValue("is_active", contractData?.status == 1 ? "yes" : "no")
    }
  }, [])

  const validationSchema = yup.object({
    contract_issue_date: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    contract: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    contract_expiry_date: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    is_active: yup
      .string('This Field is Required')
      .required('This Field is Required'),
  });

  const formik = useFormik({
    initialValues: {
      contract_issue_date: '',
      contract_expiry_date: '',
      is_active: '',
      contract: '',
      contractLoader: false
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {

      console.log("values", values)

      let extraData = {};

      if (contractData?.id) {
        extraData = {
          "contract_id": contractData?.id
        }
      }

      let data = {
        ...extraData,
        "vendor_id": vendorId,
        "start_date": values?.contract_issue_date,
        "expiry_date": values?.contract_expiry_date,
        "contract_url": values?.contract,
        "fleet_type": type,    //Van/Car
        "status": (values?.is_active == "yes") ? "1" : "0"
      }

      try {
        let apiRes = await apiCall({ method: "post", url: (contractData?.id) ? `update-fleet-vendor-contract` : "add-fleet-vendor-contract", data: data })
        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error)
        onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
      }

    },
  });

  const handleFileUpload = async (file, type) => {
    let apiData = new FormData();
    apiData.append('file', file);
    setContractError(false);
    formik.setFieldValue("contract", "");
    formik.setFieldValue("contractLoader", true)
    try {
      let apiRes = await apiCall({ method: "post", url: "upload", data: apiData });
      formik.setFieldValue("contract", apiRes?.path?.filepath);
      formik.setFieldValue("contractLoader", false)
      console.log("apiRes", apiRes?.path?.filepath, type);
    } catch (error) {
      console.log("Error", error)
    }
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout popupStatus={true} className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}>
        <div className={`${Style["modal_header"]} ${Style.addMeModal_head} !bg-white !block`}>
          <div className="flex items-center justify-between">
            <h4>{(contractData?.id) ? "Update" : "Add"} Contract</h4>
            <div onClick={onClose} className={`${Style["close_btn"]} cursor-pointer`}><XCloseIcon /></div>
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <label htmlFor="">Contract Issue Date</label>
                  <input
                    type="date"
                    name='contract_issue_date'
                    value={formik.values.contract_issue_date}
                    onChange={formik.handleChange}
                  />
                  {
                    (formik.touched.contract_issue_date && Boolean(formik.errors.contract_issue_date)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.contract_issue_date && formik.errors.contract_issue_date}</span>
                      :
                      null
                  }
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <label htmlFor="">Contract Expiry Date</label>
                  <input
                    type="date"
                    name='contract_expiry_date'
                    value={formik.values.contract_expiry_date}
                    onChange={formik.handleChange}
                  />
                  {
                    (formik.touched.contract_expiry_date && Boolean(formik.errors.contract_expiry_date)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.contract_expiry_date && formik.errors.contract_expiry_date}</span>
                      :
                      null
                  }
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <label htmlFor="">Contract</label>
                  <label
                    onDrop={(e) => { e.preventDefault(); handleFileUpload(e.dataTransfer.files?.[0], "contract") }}
                    onDragOver={(e) => e.preventDefault()}
                    className="flex flex-col !items-center justify-center w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
                  >
                    {formik?.values?.contractLoader ?
                      <InnerLoader wrapperClass="!w-10 !h-10" textStatus={false} />
                      :
                      <UploadCloud className="w-10 h-10 text-gray-500 mb-2" />
                    }
                    <p className="text-gray-600 font-medium">Drag & Drop files here</p>
                    <p className="text-sm text-gray-400">or click to browse</p>
                    <input
                      type="file"
                      onChange={(e) => { handleFileUpload(e.target.files[0], "contract") }}
                      className="hidden"
                    />
                  </label>
                  {formik.values?.contract ?
                    <div className="">
                      <Link to={formik.values?.contract} target='_blank' className='inline-block'>
                        {contractError ?
                          <div className="h-20 w-20 shrink-0 rounded-md bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                            <File />
                          </div>
                          :
                          <img src={formik.values?.contract} alt={formik?.values?.companyName} className='h-20 w-20 rounded-md' onError={(e) => {
                            e.target.classList.add("hidden");
                            setContractError(true);
                          }} />
                        }
                      </Link>
                    </div>
                    :
                    null
                  }
                  {
                    (formik.touched.contract && Boolean(formik.errors.contract)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.contract && formik.errors.contract}</span>
                      :
                      null
                  }
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <label htmlFor="">Active</label>
                  {/* <input type="date" placeholder='Type Here' /> */}
                  <div className="flex items-center gap-6">
                    <div className="flex items-center gap-1">
                      <input
                        className='!h-5'
                        type="radio"
                        name='is_active'
                        checked={formik.values?.is_active == "yes"}
                        id='activeYes'
                        value={"yes"}
                        onChange={formik.handleChange}
                      // placeholder='Type is_active In Number'
                      />
                      <label htmlFor="activeYes" className='!h-5'>Yes</label>
                    </div>

                    <div className="flex items-center gap-1">
                      <input
                        className='!h-5'
                        type="radio"
                        name='is_active'
                        id='activeNo'
                        value={"no"}
                        checked={formik.values?.is_active == "no"}
                        onChange={formik.handleChange}
                      />
                      <label htmlFor="activeNo" className='!h-5'>No</label>
                    </div>
                  </div>
                  {
                    (formik.touched.is_active && Boolean(formik.errors.is_active)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.is_active && formik.errors.is_active}</span>
                      :
                      null
                  }
                </div>

              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
          <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
        </div>
      </LeftSidePopupLayout>
    </form>
  )
}

export default ContractModal